import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { FacilityManager } from '../../models/facilitymanager';
import { FacilityManagerService } from '../../services/facilitymanager.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
@Component({
  selector: 'app-facilitymanager',
  templateUrl: './facilitymanager.component.html',
  styleUrls: ['./facilitymanager.component.css']
})
export class FacilityManagerComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerFacilityManager: PageHeader;
  entity: FacilityManager = new FacilityManager();
  editingEntity: FacilityManager = new FacilityManager();
  selectedFacilityManager: FacilityManager = new FacilityManager();
  facilitymanagers: any;
  facilitymanagerColumns: any[] = [];
  listView: boolean = true;
  selectedDepartment: any;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  departments: Array<Department> = [];
  selectedEmployee: any;
  opened: boolean = false;
  details: any;
  constructor(
    private _facilitymanagerService: FacilityManagerService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _employeeService: EmployeeService,
    private _departmentService: DepartmentService,
  ) {
    this.headerFacilityManager = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');

    this.facilitymanagers = [];
    this.getAllFacilityManagers();
  }
  ngAfterViewInit(): void {
    this.facilitymanagerColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 100 },
      { field: "FacilityManagerName", title: 'Facilty Manager', filter: true, sortable: true },
      // { field: "FacilityManagerAddress", title: 'Address', filter: true, sortable: true },
      { field: "EmailId", title: 'Email', filter: true, sortable: true },
      { field: "Phone", title: 'Phone', filter: true, sortable: true },
      { field: "Active", title: 'Active', filter: false, sortable: true },
      { field: "", title: '', filter: true, sortable: true, width: 80, template: this.view }
    ];

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._facilitymanagerService.getAllFacilityManager('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<FacilityManager>) => {
      this.facilitymanagers = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._facilitymanagerService.getAllFacilityManager(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((facilitymanagers: Array<FacilityManager>) => {
        this.facilitymanagers = {
          data: facilitymanagers,
          total: facilitymanagers[0] ? facilitymanagers[0].TotalCount : 0
        }
      });
    }
  }
  Employeechanged(Employee: any) {
    if (Employee) {
      // this.getAllState(this.entity.State_Id);
      this.getEmployee('');
    }
  }
  getEmployee(filter: string) {
    this._employeeService.getEmployee(this.entity.Emp_Ref_Id).subscribe((data: any) => {
      this.entity.EmailId = data.EmailId;
      this.entity.Phone = data.Phone;
      this.selectedDepartment = { Department_Id: data.Department_Id, DepartmentName: data.DepartmentName };
      this.entity.EmployeeName = data.EmployeeName;
    })
  }
  getAllFacilityManagers() {
    this._facilitymanagerService.getAllFacilityManager('', Number(this.defaultPageSize), 1, 0, 0).subscribe((facilitymanagers: Array<FacilityManager>) => {
      this.facilitymanagers = {
        data: facilitymanagers,
        total: facilitymanagers[0] ? facilitymanagers[0].TotalCount : 0
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._facilitymanagerService.deleteFacilityManager(this.selectedFacilityManager.FacilityManager_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearFacilityManager();
            this.getAllFacilityManagers();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView = true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerFacilityManager = new PageHeader();
    headerFacilityManager.PageCaption = "Facility Manager";
    headerFacilityManager.IconClass = "bi bi-building";
    return headerFacilityManager;
  }

  deleteFacilityManager(event: any) {
    if (event.seletedRows[0]) {
      this.selectedFacilityManager.FacilityManager_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "FacilityManager",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addFacilityManager(event: any) {
    this.listView = false;
    this.clearFacilityManager();
    this.formCaption = "Add Facility Manager";
    this.getAllEmployees('');
    this.getAllDepartments('')
  }

  editFacilityManager(event: any): void {
    if (event.seletedRows[0]) {
      this._facilitymanagerService.viewFacilityManager(event.seletedRows[0]).subscribe((facilitymanagers: Array<FacilityManager>) => {
        let editFacilityManager = facilitymanagers[0] ? facilitymanagers[0] : new FacilityManager();
        if (editFacilityManager) {
          this.editingEntity = editFacilityManager;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Facility Manager";
          this.getAllEmployees('');
          this.getAllDepartments('')
          // this.selectedDepartment = { Department_Id:this.editingEntity.Department_Id, DepartmentName: this.editingEntity.DepartmentName };
          this.selectedEmployee = { Emp_Ref_Id: this.editingEntity.Emp_Ref_Id, EmployeeName: this.editingEntity.EmployeeName };

          this.entity.EntityMetaData = [
            { FieldName: 'FacilityManagerName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Facility Manager Name is required' },
            // { FieldName: 'FacilityManagerAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    this.entity.FacilityManagerName = this.entity.EmployeeName;
    // let validations = this._coreSaveService.saveValidation(this.entity);
    // if (validations.length === 0) {
    // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
    // if (this.entity.Phone.length != 10) {
    //   this.notification.showWarning("Invalid Phone No.");
    //   this.saveDisabled = false;
    //   return;
    // }
    // if (this.emailcheck === false) {
    //   this.notification.showWarning("Email not valid");
    //   this.saveDisabled = false;
    //   return;
    // }
    // else {
    // this._facilitymanagerService.checkEmail(this.entity.EmailId, this.entity.FacilityManager_Id).subscribe((response) => {
    // if (response.Success == false) {
    //   this.notification.showWarning("Email already exists");
    //   this.saveDisabled = false;
    //   return;
    // }
    // if(response.Success == true) {
    if (this.entity.FacilityManagerName == "") {
      this.notification.showWarning('Facility Manager Name is Required');
    }
    else {
      this._facilitymanagerService.checkDuplication(this.entity.FacilityManagerName, this.entity.FacilityManager_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Facility Manager already exists');
          this.saveDisabled = false;
        }
        else {

          this._facilitymanagerService.saveFacilityManager(this.entity).subscribe(() => {
            if (this.entity.FacilityManager_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearFacilityManager();
            this.getAllFacilityManagers();
          })
        }
      });
    }


    // }


    // else {
    //   this.saveDisabled = false;
    // }
    // })
  }

  gotoBack(): void {
    this.listView = true;
    this.clearFacilityManager();
  }
  refreshFacilityManager(event: any): void {
    this.facilitymanagers = [];
    this.getAllFacilityManagers();
  }
  clearFacilityManager(): void {
    this.entity = new FacilityManager();
    this.saveDisabled = false;
    this.selectedEmployee = {};
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.FacilityManager_Id = dataItem.FacilityManager_Id;
    this.details = [];
    this._facilitymanagerService.viewFacilityManager(this.entity.FacilityManager_Id).subscribe((facilitymanagers: Array<FacilityManager>) => {
      this.opened = true;
      this.details = facilitymanagers[0];
    })
  }
}
